import { create } from 'zustand';

// Combined anticipation from wager (log-ish) and parlay density (0..1)
export const computeAnticip = (wager, parlay) =>
  Math.min(1, 0.55 * Math.sqrt(wager / 5000) + 0.45 * ((parlay - 1) / 11));

export const useSimStore = create((set) => ({
  wager: 100,
  parlay: 1,
  event: 'none', // 'none' | 'win' | 'loss' | 'clutch'
  eventStart: 0,
  quality: 'high',
  fps: 0,
  started: false,
  hoveredRegion: 0,
  dragging: false,
  syncViews: true, // Sync Perspectives toggle (default ON)
  resetNonce: 0, // increment to reset camera + brain rotations
  sliceDepth: 0.22, // coronal clip-plane local z (higher = shallower cut)
  streakType: null, // 'win' | 'loss' | null
  streakCount: 0,
  clutchWinOdds: 0.5, // user-set win probability for the clutch resolution
  focusIndex: null, // which brain is focused (null = gallery)
  sliceSweep: false, // auto coronal-slice sweep
  tourActive: true, // guided auto-orbit intro on first load
  compareMode: false, // side-by-side Win vs Loss comparison
  sidebarOpen: true, // desktop left control column expanded
  isMuted: false, // global audio mute (single source of truth)
  milestone: false, // 5-win streak celebration active
  milestoneStart: 0,
  neuroTour: false, // guided narrated lobe walkthrough
  neuroStep: 0,

  setWager: (v) => set({ wager: v }),
  setParlay: (v) => set({ parlay: v }),
  triggerWin: () =>
    set((s) => {
      const count = s.streakType === 'win' ? s.streakCount + 1 : 1;
      const hitMilestone = count > 0 && count % 5 === 0;
      return {
        event: 'win',
        eventStart: performance.now() / 1000,
        streakType: 'win',
        streakCount: count,
        milestone: hitMilestone ? true : s.milestone,
        milestoneStart: hitMilestone ? performance.now() / 1000 : s.milestoneStart,
      };
    }),
  triggerLoss: () =>
    set((s) => ({
      event: 'loss',
      eventStart: performance.now() / 1000,
      streakType: 'loss',
      streakCount: s.streakType === 'loss' ? s.streakCount + 1 : 1,
    })),
  triggerClutch: () => set({ event: 'clutch', eventStart: performance.now() / 1000 }),
  clearEvent: () => set({ event: 'none' }),
  setQuality: (q) => set({ quality: q }),
  setFps: (f) => set({ fps: f }),
  setStarted: (b) => set({ started: b }),
  setHoveredRegion: (r) => set({ hoveredRegion: r }),
  setDragging: (b) => set({ dragging: b }),
  setSyncViews: (b) => set({ syncViews: b }),
  triggerReset: () => set((s) => ({ resetNonce: s.resetNonce + 1 })),
  setSliceDepth: (v) => set({ sliceDepth: v }),
  resetStreak: () => set({ streakType: null, streakCount: 0 }),
  setClutchWinOdds: (v) => set({ clutchWinOdds: v }),
  setFocus: (i) => set({ focusIndex: i }),
  toggleSliceSweep: () => set((s) => ({ sliceSweep: !s.sliceSweep })),
  setTour: (b) => set({ tourActive: b }),
  setCompare: (b) => set({ compareMode: b, focusIndex: null, tourActive: false }),
  toggleSidebar: () => set((s) => ({ sidebarOpen: !s.sidebarOpen })),
  toggleMute: () => set((s) => ({ isMuted: !s.isMuted })),
  clearMilestone: () => set({ milestone: false }),

  // Guided Neuro-Tour orchestration.
  startNeuroTour: () =>
    set({ neuroTour: true, neuroStep: 0, compareMode: false, focusIndex: null, tourActive: false, event: 'none', sliceSweep: false }),
  setNeuroStep: (n) => set({ neuroStep: n }),
  stopNeuroTour: () =>
    set({ neuroTour: false, neuroStep: 0, focusIndex: null, compareMode: false, hoveredRegion: 0, sliceSweep: false, sliceDepth: 0.22 }),
  applyTourStep: (p) =>
    set(() => ({
      focusIndex: p.focus === undefined ? null : p.focus,
      compareMode: !!p.compare,
      hoveredRegion: p.hover === undefined ? 0 : p.hover,
      sliceDepth: p.slice === undefined ? 0.22 : p.slice,
    })),
}));
